<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券标题">
                <a-input v-model="queryParam.couponName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券类型">
                <a-select v-model="queryParam.couponType" placeholder="请选择">
                  <a-select-option :key="10">代金券</a-select-option>
                  <a-select-option :key="20">折扣券</a-select-option>
                  <a-select-option :key="30">免单券</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="模块类型">
                <a-select v-model="queryParam.whType" placeholder="请选择">
                  <a-select-option :key="10">商城</a-select-option>
                  <a-select-option :key="20">维修</a-select-option>
                  <a-select-option :key="30">全景套餐</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="过期状态">
                <a-select v-model="queryParam.overdueStatus" placeholder="请选择">
                  <a-select-option :key="1">未过期</a-select-option>
                  <a-select-option :key="0">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="投放状态">
                <a-select v-model="queryParam.putonStatus" placeholder="请选择">
                  <a-select-option :key="0">取消投放</a-select-option>
                  <a-select-option :key="10">等待投放</a-select-option>
                  <a-select-option :key="20">投放中</a-select-option>
                  <a-select-option :key="30">违规下架</a-select-option>
                  <a-select-option :key="40">等待审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:coupon:add']">
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="primary"
            :disabled="single || !canBatchEdit"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['coupon:coupon:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:coupon:remove']">
            <a-icon type="delete" />删除
          </a-button>

          <a-button type="primary" @click="handleExport" v-hasPermi="['coupon:coupon:export']">
            <a-icon type="download" />导出
          </a-button>
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <CreateForm
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />
      <Detail ref="Detail"></Detail>
      <!-- 批量导入 -->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="applyForVal" slot-scope="text, record">
          <a-tooltip>
            <template #title>
              <div v-html="record.applyForVal"></div>
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>
        <span slot="reviewerEply" slot-scope="text, record">
          <a-tooltip>
            <template #title>
              <div v-html="record.reviewerEply"></div>
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>

        <span slot="reviewerStatus" slot-scope="text, record">
          {{ record.reviewerStatus == 0 ? '待审核' : record.reviewerStatus == 1 ? '通过' : '失败' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <!-- 模块类型显示 -->
        <span slot="whType" slot-scope="text, record">
          <a-tag :color="getWhTypeColor(record.whType)">
            {{ getWhTypeText(record.whType) }}
          </a-tag>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupon:edit']" v-if="operationPermissions.canEdit(record)"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:query', 'coupon:coupon:edit']" v-if="operationPermissions.canEdit(record)" />

          <a-dropdown v-hasPermi="['coupon:coupon:query', 'coupon:coupon:edit']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <!-- 详情 - 始终显示 -->
              <a-menu-item v-hasPermi="['coupon:coupon:query']">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>

              <!-- 发放优惠券 - 仅平台发放类型且投放中状态 -->
              <a-menu-item v-hasPermi="['coupon:coupon:send']" v-if="operationPermissions.canDistribute(record)">
                <a @click="handleDistribute(record)">发放优惠券</a>
              </a-menu-item>

              <!-- 查看使用记录 - 始终显示 -->
              <a-menu-item v-hasPermi="['coupon:userecord:list']">
                <a @click="looking(record)">查看使用记录</a>
              </a-menu-item>

              <!-- 查看发放记录 - 始终显示 -->
              <a-menu-item v-hasPermi="['88951f1c8772492a15ab9cc7d7b2dd46b:0:b']">
                <a @click="handleDistributeRecord(record)">查看发放记录</a>
              </a-menu-item>

              <!-- 信息统计 - 始终显示 -->
              <a-menu-item v-hasPermi="['coupon:coupon:tj']">
                <a @click="infoALL(record)">信息统计</a>
              </a-menu-item>

              <!-- 查询用户关联 - 仅客户领取类型 -->
              <a-menu-item v-hasPermi="['coupon:user:list']" v-if="operationPermissions.canShowUserList(record)">
                <a @click="handleUserList(record)">查询用户关联</a>
              </a-menu-item>

              <!-- 审核 - 仅等待审核状态 -->
              <a-menu-item v-hasPermi="['coupon:coupon:check']" v-if="operationPermissions.canAudit(record)">
                <a @click="handleAudit(record)">审核</a>
              </a-menu-item>

              <!-- 投放 - 等待投放/取消投放/违规下架状态 -->
              <a-menu-item v-hasPermi="['coupon:coupon:put']" v-if="operationPermissions.canLaunch(record)">
                <a @click="handleLaunch(record)">投放</a>
              </a-menu-item>

              <!-- 取消投放 - 投放中/等待投放状态 -->
              <a-menu-item v-hasPermi="['coupon:coupon:cancelPut']" v-if="operationPermissions.canCancelLaunch(record)">
                <a @click="handleCancelLaunch(record)">取消投放</a>
              </a-menu-item>

              <!-- 违规下架 - 投放中状态 -->
              <a-menu-item v-hasPermi="['coupon:coupon:illegal']" v-if="operationPermissions.canViolate(record)">
                <a @click="handleViolate(record)">违规下架</a>
              </a-menu-item>

              <!-- 查看激活码 - 仅激活码领取类型 -->
              <a-menu-item v-hasPermi="['df5d625d7eda531ee28cf818defdea1d:0:g']" v-if="operationPermissions.canShowCode(record)">
                <a @click="handleActivationCode(record)">查看激活码</a>
              </a-menu-item>

              <!-- 删除 - 仅取消投放、等待投放、违规下架、等待审核状态 -->
              <a-menu-item v-hasPermi="['coupon:coupon:remove']" v-if="operationPermissions.canDelete(record)">
                <a v-hasPermi="['coupon:coupon:remove']" @click="handleDelete(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <a-modal
      title="优惠券审核"
      :visible="auditModalVisible"
      @ok="handleAuditSubmit"
      @cancel="auditModalVisible = false"
    >
      <a-form-model
        ref="auditForm"
        :model="auditForm"
        :rules="auditRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="审核结果" prop="auditStatus">
          <a-select v-model="auditForm.auditStatus" placeholder="请选择审核结果">
            <a-select-option :value="10">通过</a-select-option>
            <a-select-option :value="50">不通过</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="审核说明" prop="auditingVal" v-if="auditForm.auditStatus === 50">
          <a-textarea
            v-model="auditForm.auditingVal"
            placeholder="请输入审核不通过原因"
            :rows="3"
            :max-length="200"
            show-word-limit
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <CouponDistributeDrawer ref="distributeDrawer" @success="getList" />
    <PanoramaCouponDistributeDrawer ref="panoramaDistributeDrawer" @success="getList" />
    <CouponCodeDrawer ref="codeDrawer" />
    <CouponDetailDrawer ref="detailDrawer" />
    <CouponUserDrawer ref="userDrawer" />
    <UserCouponStatDrawer ref="statDrawer" />
    <UserCouponUsedStatDrawer ref="infoDrawer" />
    <DistributeRecordDrawer ref="distributeRecordDrawer" />
    <CouponActivationDrawer ref="activationDrawer" />
  </page-header-wrapper>
</template>

<script>
import {
  couponlist,
  deletecouponlist,
  cancelCouponLaunch,
  auditCoupon,
  updatePutonStatus,
  updatePutonStatusput,
} from '@/api/coupon/controller/index.js'
import CreateForm from './modules/CreateForm'
import Detail from './modules/detail'
import { tableMixin } from '@/store/table-mixin'
import CouponDistributeDrawer from './modules/CouponDistributeDrawer'
import CouponCodeDrawer from './modules/CouponCodeDrawer.vue'
import CouponDetailDrawer from './modules/CouponDetailDrawer.vue'
import CouponUserDrawer from './modules/CouponUserDrawer.vue'
import UserCouponStatDrawer from './modules/UserCouponStatDrawer'
import UserCouponUsedStatDrawer from './modules/UserCouponUsedStatDrawer.vue'
import PanoramaCouponDistributeDrawer from './modules/PanoramaCouponDistributeDrawer.vue'
import DistributeRecordDrawer from './modules/DistributeRecordDrawer.vue'
import CouponActivationDrawer from './modules/CouponActivationDrawer.vue'
export default {
  name: 'Post',
  components: {
    CreateForm,
    CouponDistributeDrawer,
    Detail,
    CouponCodeDrawer,
    CouponDetailDrawer,
    CouponUserDrawer,
    UserCouponStatDrawer,
    PanoramaCouponDistributeDrawer,
    UserCouponUsedStatDrawer,
    DistributeRecordDrawer,
    CouponActivationDrawer,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      auditModalVisible: false,
      auditForm: {
        id: null,
        auditStatus: null,
        auditingVal: '',
      },
      auditRules: {
        auditStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        auditingVal: [
          { required: true, message: '请输入审核不通过原因', trigger: 'blur' },
          { min: 5, max: 200, message: '长度在 5 到 200 个字符', trigger: 'blur' },
        ],
      },
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        couponName: undefined,
        mobile: undefined,
        couponType: undefined,
        whType: undefined,
        overdueStatus: undefined,
        putonStatus: undefined,
      },
      columns: [
        {
          title: '优惠券标题',
          dataIndex: 'couponName',
          align: 'center',
          ellipsis: true,
          width: '15%',
          // fixed: 'left',
        },
        {
          title: '优惠券类型',
          dataIndex: 'couponType',
          align: 'center',
          width: '9%',
          customRender: (text) => {
            const map = { 10: '代金券', 20: '折扣券', 30: '免单券' }
            return map[text] || text
          },
        },
        {
          title: '模块类型',
          dataIndex: 'whType',
          align: 'center',
          width: '7%',
          scopedSlots: { customRender: 'whType' },
        },
        {
          title: '优惠内容',
          dataIndex: 'reduceAmount',
          align: 'center',
          width: '15%',
          customRender: (text, record) => {
            const { couponType, reduceAmount, couponDiscount } = record
            if (couponType === 10) {
              // 代金券
              return `减 ${reduceAmount} 元`
            }
            if (couponType === 20) {
              // 折扣券
              return `${(couponDiscount * 10).toFixed(1)} 折`
            }
            if (couponType === 30) {
              // 免单券
              return '免单'
            }
            return '-'
          },
        },
        {
          title: '使用门槛',
          dataIndex: 'cashCondition',
          align: 'center',
          width: '9%',
          customRender: (text) => `满¥${text}可用`,
        },
        {
          title: '有效期',
          align: 'center',
          width: '13%',
          customRender: (text, record) => {
            if (record.validTimeType === 1) {
              return `${record.startTime} ~ ${record.endTime}`
            } else {
              return `领取后 ${record.validDays} 天内有效`
            }
          },
        },
        {
          title: '过期状态',
          dataIndex: 'overdueStatus',
          align: 'center',
          width: '7%',
          customRender: (text) => {
            return text === 1 ? '未过期' : '已过期'
          },
        },
        {
          title: '投放状态',
          dataIndex: 'putonStatus',
          align: 'center',
          width: '7%',
          customRender: (text) => {
            const map = {
              0: '取消投放',
              10: '等待投放',
              20: '投放中',
              30: '违规下架',
              40: '等待审核',
            }
            return map[text] || text
          },
        },
        {
          title: '库存',
          dataIndex: 'stocks',
          align: 'center',
          width: '5%',
          customRender: (text, record) => {
            return record.sourceStock === 0 ? '无限制' : text
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          width: '15%',
          // fixed: 'right',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    // 批量修改权限：选中的所有记录都必须是可修改状态
    canBatchEdit() {
      if (!this.selectedRows || this.selectedRows.length === 0) return false
      return this.selectedRows.every(record =>
        [0, 30].includes(record.putonStatus)
      )
    },
    // 操作列显示/隐藏
    operationPermissions() {
      return {
        // 修改：只有下架状态可以修改
        canEdit: (record) => {
          return [0, 10, 30, 40].includes(record.putonStatus)
        },

        // 发放优惠券：仅平台发放类型且投放中状态
        canDistribute: (record) => {
          return record.getWay === 10 && record.putonStatus === 20
        },

        // 查询用户关联：仅客户领取类型
        canShowUserList: (record) => {
          return record.getWay === 0
        },

        // 审核：仅等待审核状态
        canAudit: (record) => {
          return record.putonStatus === 40
        },

        // 投放：等待投放/取消投放/违规下架状态
        canLaunch: (record) => {
          return [10, 0, 30].includes(record.putonStatus)
        },

        // 取消投放：投放中/等待投放状态
        canCancelLaunch: (record) => {
          return [10, 20].includes(record.putonStatus)
        },

        // 违规下架：仅投放中状态
        canViolate: (record) => {
          return record.putonStatus === 20
        },

        // 查询优惠券激活码：仅激活码领取类型
        canShowCode: (record) => {
          return record.getWay === 20
        },

        // 删除：只有取消投放、等待投放、违规下架、等待审核状态可以删除
        canDelete: (record) => {
          return [0, 10, 30, 40].includes(record.putonStatus)
        },
      }
    },
  },
  watch: {},
  methods: {
    // 获取模块类型颜色
    getWhTypeColor(type) {
      const colors = {
        0: 'default',
        10: 'blue',
        20: 'green',
        30: 'orange',
      }
      return colors[type] || 'default'
    },

    // 获取模块类型文本
    getWhTypeText(type) {
      const texts = {
        0: '通用',
        10: '商城',
        20: '维修',
        30: '全景套餐',
      }
      return texts[type] || '未知类型'
    },

    looking(record) {
      this.$refs.statDrawer.open(record)
    },
    infoALL(record) {
      this.$refs.infoDrawer.open(record)
    },
    handleUserList(record) {
      this.$refs.userDrawer.open(record.id)
    },
    handleCode(record) {
      this.$refs.codeDrawer.open(record.id)
    },
    handleDetail(record) {
      this.$refs.detailDrawer.open(record)
    },

    handleDistribute(record) {
      // 如果是全景套餐类型
      if (record.whType === 30) {
        this.$refs.panoramaDistributeDrawer.open(record.id)
      } else {
        // 选择用户发放优惠券弹窗
        this.$refs.distributeDrawer.open(record.id)
      }
    },
    handleDistributeRecord(record) {
      this.$refs.distributeRecordDrawer.open(record)
    },
    handleActivationCode(record) {
      this.$refs.activationDrawer.open(record)
    },
    handleLaunch(row) {
      const that = this
      this.$confirm({
        title: '确认投放？',
        content: '投放后优惠券将立即对用户可见。',
        onOk() {
          updatePutonStatusput({ id: row.id })
            .then(() => {
              that.$message.success('投放成功')
              that.getList()
            })
            .catch(() => {
              that.$message.error('投放失败')
            })
        },
      })
    },
    handleViolate(row) {
      const that = this
      this.$confirm({
        title: '确认违规下架？',
        content: '下架后优惠券将停止投放，已领取用户仍可使用。',
        onOk() {
          updatePutonStatus({ id: row.id })
            .then(() => {
              that.$message.success('违规下架成功')
              that.getList()
            })
            .catch(() => {
              that.$message.error('违规下架失败')
            })
        },
      })
    },
    // 打开审核弹框
    handleAudit(record) {
      this.auditForm = {
        id: record.id,
        auditStatus: 10, // 默认选择通过
        auditingVal: '',
      }
      this.auditModalVisible = true
    },

    handleAuditSubmit() {
      this.$refs.auditForm.validate((valid) => {
        if (!valid) return // 校验未通过直接拦截

        const params = {
          id: this.auditForm.id,
          auditStatus: this.auditForm.auditStatus,
          auditingVal: this.auditForm.auditingVal,
        }

        auditCoupon(params)
          .then(() => {
            this.$message.success('审核提交成功')
            this.auditModalVisible = false
            this.getList()
          })
          .catch(() => {
            this.$message.error('审核提交失败')
          })
      })
    },
    handleCancelLaunch(record) {
      const that = this
      this.$confirm({
        title: '确认取消投放？',
        content: '取消后该优惠券将不再对用户展示，但已领取的用户仍可使用。',
        onOk() {
          return cancelCouponLaunch({ id: record.id })
            .then(() => {
              that.$message.success('取消投放成功')
              that.getList()
            })
            .catch(() => {
              that.$message.error('取消投放失败')
            })
        },
      })
    },
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      couponlist(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {},
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        couponName: undefined,
        mobile: undefined,
        couponType: undefined,
        whType: undefined,
        overdueStatus: undefined,
        putonStatus: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return deletecouponlist(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'coupon/coupon/export',
            {
              ...that.queryParam,
            },
            `优惠券列表信息${new Date().getTime()}.xlsx`,
            'GET'
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
